import { createFileRoute } from "@tanstack/react-router";
import LegalNotice from "@/pages/LegalNotice";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/aviso-legal")({
  head: () => pageHead("legalNotice", "es"),
  component: LegalNotice,
});
